import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CacheBuster } from 'ts-cacheable';
import { HttpClient } from '@angular/common/http';
import { Goal } from 'src/app/goal/model/goal';

const goalsCacheBuster = new Subject<void>();

@Injectable({
  providedIn: 'root'
})
export class GoalService
{
  constructor(private http: HttpClient) { }

  /**
   * Delete a Goal.
   *
   * @param id Goal id
   */
  @CacheBuster(
    {
      cacheBusterNotifier: goalsCacheBuster
    })
  public deleteGoal(id: number): Observable<Goal>
  {
    return this.http.delete<Goal>(`/goal/${id}`);
  }

  /**
   * Get the goal by id.
   *
   * @param id Goal ID
   */
  public getGoal(id: number): Observable<any>
  {
    return this.http.get<any>(`/goal/${id}`);
  }

  public getGoalsByMember(memberId: number): Observable<any[]>
  {
    return this.http.get<any[]>(`/goal/member/${memberId}`);
  }

  public getGoalsByCase(caseId: number): Observable<any[]>
  {
    return this.http.get<any[]>(`/goal/case/${caseId}`);
  }  

  /**
   * Save a goal.
   *
   * @param data Goal to persit
   * @param isNew Indicate if this is a new or update
   */
  public saveGoal(data: any, isNew: boolean, goalId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/goal', data);
    }
    else
    {
      return this.http.put(`/goal/${goalId}`, data);
    }
  }

  /**
   * Set Goal sort display. Sorting by 
   *    1. progress (in-progress,ongoing,other,achived)
   *    2. type display name
   *    3. goal text
   * @param d Data record
   * @returns Sort value
   */
  public setSort(d: any): string
  {
    let sort: string;
    switch (d.progress.code)
    {
      case 'in_progress':
        sort = '1';
        break;
      case 'ongoing':
        sort = '2';
        break;
      case 'achieved':
        sort = '4';
        break;
      default:
        sort = '3';
        break;
    }
    return `${sort}-${d.type.displayName}-${d.goal}`;
  }
}
